function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#FFFFFF;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M256,504c137,0,248-111,248-248S393,8,256,8S8,119,8,256S119,504,256,504z M40,256c0-118.7,96.1-216,216-216 c118.7,0,216,96.1,216,216c0,118.7-96.1,216-216,216C137.3,472,40,375.9,40,256z M371.7,238l-176-107c-15.8-8.8-35.7,2.5-35.7,21 v208c0,18.4,19.8,29.8,35.7,21l176-101C388.1,270.9,388.1,247.2,371.7,238z M192,335.8V176.9c0-4.7,5.1-7.6,9.1-5.1l134.5,81.7 c3.9,2.4,3.8,8.1-0.1,10.3L201,341C197,343.3,192,340.4,192,335.8z"
});

var SvgIconActiveOrders = function SvgIconActiveOrders(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconActiveOrders, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon_active_orders.ec5ac0da.svg";
export { ForwardRef as ReactComponent };